<template>
  <div style="overflow-x: hidden;" class="app d-flex flex-column" id="app" v-if="init" :class="classes">
    <transition name="fade" mode="out-in" appear>
      <navbar v-if="$root.user"></navbar>
    </transition>

    <transition name="fade" mode="out-in" appear>
      <router-view class="page-content flex-grow-1"></router-view>
    </transition>

    <app-modals ref="modals"></app-modals>
  </div>
</template>

<script>
  import { pick, get } from 'lodash'
  import auth from '../auth'
  import router from '../router'
  import Raven from '../raven'
  import AppAlert from '../components/app-alert'
  import ReleaseModal from '../components/release-modal'

  export default {
    metaInfo: {
      title: 'Vendoscope',
      titleTemplate: '%s – Vendoscope',
    },
    data () {
      return {
        isDev: (process.env.NODE_ENV === 'development'),
        user: null,
        init: false,
        release: null,
        store: {},
        serviceRoles: [
          'tech_superior',
          'service_superior',
          'tech_chief',
          'service_chief',
          'admin',
          'director',
          'branch_admin',
          'superior',
        ],
        indexPageRoles: [
          'admin',
          'dev_chief',
          'service_chief',
          'tech_chief',
          'fin_chief',
          'accountant_chief',
          'branch_chief',
          'analyst',
          'director',
        ],
      }
    },
    router,
    methods: {
      showModal (component, props) {
        return this.$refs.modals.show(component, props)
      },
      closeAllModals (component, props) {
        // return this.$refs.modals.closeAll()
      },
      showAlert (message) {
        return this.showModal(AppAlert, {header: message})
      },
      checkPermission (permission) {
        return this.user.permissions.includes(permission)
      },
      canCreateService () {
        return this.serviceRoles.includes(get(this.user, 'role.name'))
      },
      canSelectRegion () {
        return this.indexPageRoles.includes(get(this.user, 'role.name'))
      },
      isAdmin () {
        return this.checkPermission('admin_access')
      },
    },
    mounted () {
      auth.check()
        .then((user) => {
          this.user = user
        })
        .catch(() => {
          this.user = null
        })
        .finally(() => {
          this.init = true
        })
    },
    watch: {
      user () {
        if (Raven) {
          Raven.setUserContext(this.user
            ? pick(this.user, ['id', 'email'])
            : null,
          )
        }
      },
      release (oldRelease, newRelease) {
        if (oldRelease && newRelease) {
          this.showModal(ReleaseModal)
        }
      },
    },
    computed: {
      classes () {
        let path = this.$route.path.replace(/\//g, '-')
        if (path === '-') path = '-index'
        return `page${path}`
      },
    },
  }
</script>

<style lang="scss">
  @import "app";
  .fade-enter-active, .fade-leave-active {
    transition: opacity .1s;
  }
  .fade-enter, .fade-leave-to {
    opacity: 0;
  }
</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/app.vue